/**
 * @desc 清除策略类Map
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/approvalFlow/clearProductStrategyBean`, {
      method: "POST",

      ...options,
    }),
  );
}
